import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OtkList } from '../../models/user-item-list';
import { Observable } from 'rxjs';
import { Record } from '../../models/record';
import { environment } from '../../../environments/environment';
import { CreateListRequest, UpdateListRequest } from './models/list.request';

@Injectable({
  providedIn: 'root',
})
export class EditListService {
  private readonly http = inject(HttpClient);

  createList(userId: string, list: CreateListRequest, record?: Record): Observable<OtkList> {
    const url = `${environment.apiUrl}/patrons/${userId}/lists`;

    const params = [
      `listName=${list.name}`,
      `listDescription=${list.description ?? ''}`,
      `privateList=${list.privateList ?? true}`,
      `selectedCoverIdx=${list.selectedCoverIdx ?? 0}`,
    ];

    if (record) {
      params.push(`recordId=${record.id}`);
    }

    return this.http.post<OtkList>(url, params.join('&'), {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      }),
    });
  }

  editList(list: UpdateListRequest): Observable<OtkList> {
    const url = `${environment.apiUrl}/patrons/${list.userId}/lists/${list.id}`;

    const params = [
      `listName=${list.name}`,
      `listDescription=${list.description ?? ''}`,
      `privateList=${list.privateList}`,
      `selectedCoverIdx=${list.selectedCoverIdx}`,
      `deleteCustomCover=${list.deleteCustomCover}`,
    ];

    return this.http.put<OtkList>(url, params.join('&'), {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      }),
    });
  }
}
